import { Box, Heading, Icon, Text, Tooltip } from '@redriverpress/system'
import PropTypes from 'prop-types'

const CompactDescription = ({ description }) => {
  return (
    <Tooltip.Root delayDuration={0}>
      <Tooltip.Trigger asChild>
        <Box
          border='1px solid'
          borderRadius='circular'
          size={24}
          display='flex'
          justifyContent='center'
          alignItems='center'
        >
          <Icon icon='info' weight='solid' fontSize={0} />
        </Box>
      </Tooltip.Trigger>
      <Tooltip.Content side='top'>
        <Tooltip.Arrow />
        <Text maxWidth='30ch'>
          <Text as='span' mt={0}>
            {description}
          </Text>
        </Text>
      </Tooltip.Content>
    </Tooltip.Root>
  )
}

CompactDescription.propTypes = {
  description: PropTypes.string.isRequired,
}

export default function PageHeader({ title, description, measure, compact }) {
  return (
    <Box>
      <Box display='flex' justifyContent='space-between' alignItems='center'>
        <Heading as='h2' mb={3}>
          {title}
        </Heading>
        {description && compact ? (
          <CompactDescription description={description} />
        ) : null}
      </Box>
      {description && !compact ? (
        <Text measure={measure}>{description}</Text>
      ) : null}
    </Box>
  )
}

PageHeader.defaultProps = {
  description: null,
  compact: false,
  measure: true,
}

PageHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  description: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  compact: PropTypes.bool,
  measure: PropTypes.bool,
}
